import React from "react";
import { getFormattedPrice } from "../../../services/helper";

const PaymentSummary = ({ total, remainingBalance, payments, onRemovePayment }) => (
  <div className="payment-summary mb-2" style={{ fontSize: "16px" }}>
    <div className="d-flex justify-content-between">
      <span style={{ color: "white" }}>Total:</span>
      <span style={{ color: "white" }}>{getFormattedPrice(total)}</span>
    </div>
    <div className="d-flex justify-content-between">
      <span style={{ color: "white" }}>Balance:</span>
      <span style={{ color: "white" }}>{getFormattedPrice(remainingBalance)}</span>
    </div>
    {payments.length > 0 && (
      <div className="mt-1">
        {payments.map((payment) => (
          <div key={payment.id} className="d-flex justify-content-between align-items-center" style={{ fontSize: "14px" }}>
            <span style={{ color: "#ccc" }}>{payment.type}:</span>
            <div className="d-flex align-items-center">
              <span style={{ color: "#ccc", marginRight: "5px" }}>{getFormattedPrice(payment.amount)}</span>
              <i 
                className="fa fa-times" 
                style={{ color: "#ff6b6b", cursor: "pointer", fontSize: "12px" }}
                onClick={() => onRemovePayment(payment.id)}
                title="Remove payment"
              ></i>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default PaymentSummary;